import { Observable, ApiConfig, tokenService } from "sbtech-sports-api";
/**
 * SportDataGateway class provides interface for communication between sports data service and blocks though sports data client.
 */
var SportDataGateway = /** @class */ (function () {
    /**
    * Creates an instance of SportDataGateway
    * @param {SportDataGatewayConfig} gatewayConfig Provides configuration for sports data client
    */
    /* istanbul ignore next */
    function SportDataGateway(gatewayConfig) {
        this.gatewayConfig = gatewayConfig;
        this.subscriptions = [];
        if (gatewayConfig.authToken) {
            tokenService.apiAccessToken = gatewayConfig.authToken;
        }
        ;
    }
    /**
     * Activate method does nothing and has beed added for consistency
    */
    SportDataGateway.prototype.activate = function () {
    };
    /**
     * Subscribes for snapshots/updates from sports data API
     * @param {SportDataGatewayQueryInfo} queryInfo query sports data client
    */
    /* istanbul ignore next */
    SportDataGateway.prototype.subscribe = function (queryInfo) {
        var subscription = Observable.fromQuery({
            query: queryInfo.query,
            locale: queryInfo.locale,
            composeFullEvent: queryInfo.composeFullEvent,
            from: queryInfo.from,
            timeRange: queryInfo.timeRange,
            includeMarkets: queryInfo.includeMarkets,
            fastPreloadAmount: queryInfo.fastPreloadAmount,
            format: "ODataV3"
        }, this.getApiConfig());
        var observer = subscription.subscribe(queryInfo.onMessageHandler, queryInfo.onErrorHandler, queryInfo.onCompleteHandler);
        this.subscriptions.push(observer);
    };
    /**
    * Deactivate method removes all subscriptions of current instance
    */
    /* istanbul ignore next */
    SportDataGateway.prototype.deactivate = function () {
        this.subscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    };
    /* istanbul ignore next */
    SportDataGateway.prototype.getApiConfig = function () {
        var apiUrl = this.gatewayConfig.serviceUrl + this.gatewayConfig.apiEndpoint;
        var pushApiUrl = this.gatewayConfig.serviceUrl + this.gatewayConfig.pushEndpoint;
        return new ApiConfig(apiUrl, pushApiUrl);
    };
    return SportDataGateway;
}());
export { SportDataGateway };
//# sourceMappingURL=SportDataGateway.js.map